import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

import type { CardsData } from "./types";

const defaultSatCardsData = (): CardsData => ({
  modules_sent: 0,
  at_risk: 0,
  protected: 0,
  active_users: 0,
  licences: 0,
  optionals: null,
});

type CardsRequest = {
  // Consumers pass the route-derived org id, which can be null before an org
  // is resolved; mirrors the previously-untyped Vuex action contract.
  globalOrganisationID: string | null;
};

export const useDashCardsStore = defineStore("dashCards", () => {
  const protectedCustomers = ref<number | null>(null);
  const atRiskCustomers = ref<number | null>(null);
  const satCardsData = ref<CardsData>(defaultSatCardsData());

  const atRiskSat = computed(() => satCardsData.value.at_risk);
  const protectedSat = computed(() => satCardsData.value.protected);

  const getSatCardData = async ({ globalOrganisationID }: CardsRequest) => {
    const res = await $http.get<CardsData>(
      `${getApiClientUrl()}/v1/cams/manager/sat/${globalOrganisationID}/customers/cards`,
    );

    satCardsData.value = res.data;
  };

  const getAtRiskAndProtected = async ({
    globalOrganisationID,
  }: CardsRequest) => {
    const res = await $http.get<{ protected: number; at_risk: number }>(
      `${getApiClientUrl()}/v1/cams/manager/${globalOrganisationID}/cards/at-risk`,
    );

    atRiskCustomers.value = res.data.at_risk;
    protectedCustomers.value = res.data.protected;
  };

  return {
    protectedCustomers,
    atRiskCustomers,
    satCardsData,
    atRiskSat,
    protectedSat,
    getSatCardData,
    getAtRiskAndProtected,
  };
});
